import type { RulerConfig } from "./types";

/** Ruler thicknesses offered by the Ruler tool panel. */
export const RULER_SIZES = ["sm", "md", "lg"] as const;
export type RulerSize = (typeof RULER_SIZES)[number];

export const DEFAULT_RULER_SIZE: RulerSize = "md";

type RulerSizeConfig = Pick<
  RulerConfig,
  "thickness" | "graduationLength" | "subGraduationLength" | "labelFontSize"
>;

/**
 * Bar dimensions per size (canvas pixels): graduations and labels follow the
 * thickness. "md" is the historical ruler (DEFAULT_RULER_CONFIG).
 */
export const RULER_SIZE_CONFIGS: Record<RulerSize, RulerSizeConfig> = {
  sm: {
    thickness: 18,
    graduationLength: 8,
    subGraduationLength: 4,
    labelFontSize: 8,
  },
  md: {
    thickness: 25,
    graduationLength: 12,
    subGraduationLength: 6,
    labelFontSize: 9,
  },
  lg: {
    thickness: 34,
    graduationLength: 16,
    subGraduationLength: 8,
    labelFontSize: 11,
  },
};

/** Stored value → size; anything unknown falls back to the default. */
export function toRulerSize(value: unknown): RulerSize {
  return RULER_SIZES.includes(value as RulerSize)
    ? (value as RulerSize)
    : DEFAULT_RULER_SIZE;
}
